import React from "react";
import styled from "styled-components";

const DisabledIcon = styled.i`
    color: red;
    font-size: 100%;
    background-color: white;
`;

const OptionRadioButton = (props) => {
    return (
        <div className="w-1/2 md:w-1/4 lg:w-1/5 px-2 pb-6 flex flex-col">
            <div
                onClick={() =>
                    props.option.active &&
                    props.selectOption(props.type, props.option.value)
                }
                className={`transition duration-200 ease-in-out border relative flex-grow bg-white border-solid rounded py-4 px-4 cursor-pointer border hover:border-yellow-100 ${props
                    .option.selected && "border-b-4 border-yellow-100"} `}
            >
                {props.option.popular && (
                    <div
                        style={{right: "8px", top: "8px", fontSize: "11px"}}
                        className="px-2 py-1 absolute bg-red-500 text-white rounded"
                    >
                        <span
                            style={{fontSize: "11px"}}
                            className="font-bold "
                        >
                            populair
                        </span>
                    </div>
                )}

                {!props.option.active && (
                    <div className="black-overlay-2 absolute inset-0 rounded flex justify-center items-center">
                        <span className="text-center text-sm px-2">
                            Combinatie niet mogelijk
                        </span>
                    </div>
                )}

                <h6
                    className={` text-center text-sm ${props.option.selected &&
                    "font-bold"}`}
                >
                    {props.option.name}
                </h6>
                {props.option.description && <span className="block text-xs text-gray-600 text-center mb-2">
                    {props.option.description}
                </span>}
            </div>
        </div>
    );
};

export default OptionRadioButton;
